module.exports = __webpack_public_path__ + "img/icon-brand-asana-active.d0b835b1.svg";